import { createFileRoute } from "@tanstack/react-router";
import { ResetPassword } from "@/app/components/ResetPassword";

export const Route = createFileRoute("/auth/reset-password")({
  component: ResetPassword,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: typeof search.token === "string" ? search.token : undefined,
      error: typeof search.error === "string" ? search.error : undefined,
    };
  },
});
